import { ChangeEvent, useState, useEffect } from "react"
import { H2 } from "components/ui/typography/titles/Titles"
import { InstructionsForm } from "../InstructionsForm/InstructionsForm"
import { ConfigurationModal } from "components/ui/modals/ConfigurationModal/ConfigurationModal"
import { useInstructionsStore } from "store/aiAgent.store"
import { useUpdateInstruction } from "hooks/api/aiAgent/aiAgent.hook"
import { useApiErrorFormatter } from "hooks/apiErrorFormatter.hook"
import { AxiosError } from "axios"
import { useMessage } from "hooks/message.hook"
import style from "./EditInstruction.module.scss"

const { editInstruction, container, form, title } = style

type Props = { isModalOpen: boolean; setModalClose: () => void; refetchInstructions: () => void }

export const EditInstruction = ({ isModalOpen, setModalClose, refetchInstructions }: Props) => {
	const [isNumbersValid, setIsNumbersValid] = useState(true)
	const [showValidationError, setShowValidationError] = useState(false)
	const { instruction, clearInstructions, setInstruction } = useInstructionsStore()
	const { success: successMessage } = useMessage()
	const { mutate: updateInstruction } = useUpdateInstruction()
	const { formatError } = useApiErrorFormatter()

	useEffect(() => {
		if (isNumbersValid && showValidationError) {
			setShowValidationError(false)
		}
	}, [isNumbersValid, showValidationError])

	const saveHandle = () => {
		if (!isNumbersValid) {
			setShowValidationError(true)
			return
		}
		updateInstruction(
			{
				question: instruction.question,
				prompt: instruction.prompt,
				sections: instruction.sections,
				questionId: instruction.questionId,
			},
			{
				onSuccess: () => {
					refetchInstructions()
					setModalClose()
					clearInstructions()
					successMessage("Instruction updated successfully")
				},
				onError: (e) => {
					if (e instanceof AxiosError) {
						formatError(e)
					}
				},
			},
		)
	}

	const setSectionNumbers = (newNumber: string[]) => {
		setInstruction({ sections: newNumber })
	}

	const onEditorChange = (value: string | undefined) => {
		setInstruction({ prompt: value })
	}

	const onQuestionChange = (e: ChangeEvent<HTMLInputElement>) => {
		setInstruction({ question: e.target.value })
	}

	return (
		<ConfigurationModal
			isModalOpen={isModalOpen}
			setModalClose={setModalClose}
			saveHandle={saveHandle}
			submitButtonText="Save"
		>
			<div className={editInstruction}>
				<div className={container}>
					<H2 className={title}>Edit instruction</H2>
					<div className={form}>
						<InstructionsForm
							question={instruction.question}
							onQuestionChange={onQuestionChange}
							editorValue={instruction.prompt}
							onEditorChange={onEditorChange}
							numbers={instruction.sections}
							setNumbers={setSectionNumbers}
							onNumbersValidationChange={setIsNumbersValid}
							isNumbersValid={isNumbersValid}
							showValidationError={showValidationError}
						/>
					</div>
				</div>
			</div>
		</ConfigurationModal>
	)
}
